import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ProfileRead } from '../../shared/profile-read.model';
import { TranslationService, NotificationService } from 'src/app/shared';
import { ProfileService } from '../../shared/profile.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { GlobalSettingsService } from 'src/app/admin/global-settings/shared/global-settings.service';

@Component({
  selector: 'wl-profile-edit-delete',
  templateUrl: './profile-edit-delete.component.html',
  styleUrls: ['./profile-edit-delete.component.less'],
  standalone: false,
  // Own instance: a hidden ProfileEditComponent in the top-nav create-profile dialog also renders this component.
  providers: [ConfirmationService],
})
export class ProfileEditDeleteComponent implements OnInit {
  @Input() profile: ProfileRead;

  deleting = false;
  IsAnnonymousProfileID: boolean = true;

  constructor(
    private _confirmationService: ConfirmationService,
    private _profileService: ProfileService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _globalSettingsService: GlobalSettingsService
  ) {}

  ngOnInit(): void {
    this._globalSettingsService.getOnlinePaymentSettings().then((settings) => {
      this.IsAnnonymousProfileID = this.profile.ProfileId == settings.Revenue_AnnonymousProfileID;
    });
  }
  deleteProfile(profile: ProfileRead) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.edit.delete-profile.delete-confirm-message'),
      key: 'deleteProfile',
      accept: () => {
        this.deleting = true;
        this._profileService
          .deleteProfile(profile.ProfileId)
          .then(() => {
            this._navigationService.navigateToProfileFinder();
          })
          .catch((err) => {
            this._notificationService.httpError(err);
          })
          .finally(() => {
            this.deleting = false;
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
